module.exports = __webpack_public_path__ + "img/HQ-PA2W1S-T.e8ed21d8.jpg";